const resolved = task => !!task.completedAt || ['complete', 'completed', 'closed', 'done', 'cancelled', 'canceled', 'resolved'].includes(String(task.status || '').trim().toLowerCase())
function timestamp(value) {
  if (value == null || value === '') return Infinity
  const milliseconds = value?.seconds != null ? Number(value.seconds) * 1000 : new Date(value).getTime()
  return Number.isFinite(milliseconds) ? milliseconds : Infinity
}
export function compareTaskDueDate(a, b) {
  const statusOrder = Number(resolved(a)) - Number(resolved(b))
  if (statusOrder) return statusOrder
  const aDue = timestamp(a.dueAt ?? a.dueDate), bDue = timestamp(b.dueAt ?? b.dueDate)
  if (aDue !== bDue) return aDue < bDue ? -1 : 1
  const aCreated = timestamp(a.createdAt), bCreated = timestamp(b.createdAt)
  if (aCreated !== bCreated) return aCreated < bCreated ? -1 : 1
  return String(a.id || a.number || '').localeCompare(String(b.id || b.number || ''))
}
